/* ═══════════════════════════════════════════════════════
   ÁNIMA SUPLEMENTOS — Landing JS (Shopify build)
   Combina: handleAddToCart + Preloader + Sticky Bar + Reveal + FAQ
   Lee config de window.ANIMA_CONFIG (inyectado vía Liquid)
══════════════════════════════════════════════════════ */

'use strict';

(function () {
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));

  /* ── Shopify Cart AJAX API ─────────────────────────── */
  async function handleAddToCart(variantId) {
    if (!variantId) {
      console.error('[Ánima] variantId requerido');
      return;
    }
    const cfg = window.ANIMA_CONFIG || {};
    const cartAddUrl = cfg.cartAddUrl || '/cart/add.js';
    const cartUrl = cfg.cartUrl || '/cart';

    const btns = document.querySelectorAll('[data-cart-btn]');
    btns.forEach(b => { b.disabled = true; b.dataset.originalText = b.textContent; b.textContent = 'Agregando...'; });

    try {
      const res = await fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      });

      if (!res.ok) {
        const errBody = await res.text();
        throw new Error(`Cart error ${res.status}: ${errBody}`);
      }

      btns.forEach(b => { b.textContent = '✓ Agregado'; });
      setTimeout(() => {
        window.location.href = cartUrl;
      }, 600);
    } catch (err) {
      console.error('[Ánima] handleAddToCart error:', err.message);
      btns.forEach(b => { b.disabled = false; b.textContent = b.dataset.originalText || 'Agregar al Carrito'; });
      alert('No pudimos agregar el producto al carrito. Intenta de nuevo o recarga la página.');
    }
  }
  window.handleAddToCart = handleAddToCart;

  /* ── 1. Preloader ───────────────────────────────────── */
  (function initPreloader() {
    const loader = $('#preloader');
    if (!loader) return;
    const hide = () => loader.classList.add('hidden');
    if (document.readyState === 'complete') {
      setTimeout(hide, 400);
    } else {
      window.addEventListener('load', () => setTimeout(hide, 400), { once: true });
      setTimeout(hide, 3000);
    }
  })();

  /* ── 2. Sticky Top Bar ──────────────────────────────── */
  function initStickyBar() {
    const bar = $('#sticky-bar');
    const products = $('#products');
    if (!bar || !products) return;
    function update() {
      const { bottom } = products.getBoundingClientRect();
      bar.classList.toggle('visible', bottom < 0);
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ── 3. Scroll Reveal ───────────────────────────────── */
  function initReveal() {
    if (!('IntersectionObserver' in window)) {
      $$('.reveal, .reveal-r').forEach(el => el.classList.add('visible'));
      return;
    }
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });
    $$('.reveal, .reveal-r').forEach(el => io.observe(el));
  }

  /* ── 4. FAQ Acordeón ────────────────────────────────── */
  function initFaq() {
    $$('.faq-item').forEach(item => {
      const btn = item.querySelector('.faq-q');
      if (!btn) return;
      btn.addEventListener('click', () => {
        const isOpen = item.classList.contains('open');
        $$('.faq-item.open').forEach(openItem => {
          openItem.classList.remove('open');
          const q = openItem.querySelector('.faq-q');
          if (q) q.setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ── 5. Smooth Anchor Scroll ────────────────────────── */
  function initSmoothAnchors() {
    $$('a[href^="#"]').forEach(a => {
      a.addEventListener('click', e => {
        const id = a.getAttribute('href').slice(1);
        if (!id) return;
        const el = document.getElementById(id);
        if (!el) return;
        e.preventDefault();
        const offset = id === 'hero' ? 0 : 80;
        window.scrollTo({
          top: el.getBoundingClientRect().top + window.scrollY - offset,
          behavior: 'smooth',
        });
      });
    });
  }

  /* ── Init on DOMContentLoaded ───────────────────────── */
  function init() {
    initStickyBar();
    initReveal();
    initFaq();
    initSmoothAnchors();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
